import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { requests } from "../../services/http-common";
import { Loader } from "../../components/Loader/Loader";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import { ANALYTICS_REPORTS } from "../../constants/constants";
import styles from "./Analytics.module.scss";

interface EmbedTokenResponse {
  embedToken: string;
  embedUrl: string;
  reportId: string;
}

export function Analytics() {
  const { reportId } = useParams<{ reportId: string }>();

  const { data, isLoading, error } = useQuery<EmbedTokenResponse>({
    queryKey: ["analytics-embed-token", reportId],
    queryFn: () => requests.get(`/analytics/embed-token/${reportId}`),
    enabled: !!reportId,
    refetchOnWindowFocus: false,
    retry: false,
  });

  if (isLoading) return <Loader />;

  if (error || !data) {
    return <h2 className={styles.errorMessage}>Report not available</h2>;
  }

  const report = ANALYTICS_REPORTS.find((r) => r.id === reportId);

  return (
    <>
      <SectionHeader title={report?.name ?? "Analytics"} />
      <PowerBIEmbed
        embedConfig={{
          type: "report",
          id: data.reportId,
          embedUrl: data.embedUrl,
          accessToken: data.embedToken,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: { expanded: false, visible: true },
            },
          },
        }}
        cssClassName={styles.reportContainer}
      />
    </>
  );
}
